import { transformMenu } from '@/helpers/transforms'
import type { InlineMenuBlock as InlineMenuBlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import InlineMenuBlock from '../blocks/InlineMenuBlock'

export const InlineMenuConverter: JSXConverter<SerializedBlockNode<InlineMenuBlockType>> = ({
	node,
}) => {
	const { menu } = node.fields

	const menuItems = transformMenu(menu)

	return <InlineMenuBlock menu={menuItems?.menuItems ?? []} title={menuItems?.title} />
}
